import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { AnalyticProvider } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { useTitle } from '@application/use_title';
import { TabNavigation } from '@cellula/react';
import { useResolve, withNewContainer } from '@visiba/instantiation';
import { PropsWithChildren, useEffect } from 'react';
import { VisitsController } from './view_patient_cases.controller';

export const Root = withNewContainer(function Root(props: PropsWithChildren) {
	const controller = useResolve(VisitsController);
	const analyticService = useResolve(AnalyticService);

	useTitle(withTranslation('PW.Component.Visits.Title'));

	useEffect(
		function analyticQuirk_whenComponentMounts() {
			analyticService.trackPageView({ customTitle: 'Visits' });
		},
		[analyticService],
	);

	useEffect(() => {
		return () => {
			controller.clearEvents();
		};
	}, [controller]);

	return (
		<AnalyticProvider category={AnalyticCategories.Visits}>
			<TabNavigation.Root defaultValue='tab1'>{props.children}</TabNavigation.Root>
		</AnalyticProvider>
	);
});
